/**
 * Used to define granular permissions a user may access.
 * The value is a Bitwise Enum, and multiple options can be added togeher
 * Also helps reduce the length of the ultimate user token
 * @typedef CRUD_PERMISSIONS
 * @property {number} CREATE Allows user to create new records (INSERT DML Statement)
 * @property {number} READ Allows user to read records (SELECT DML Statement)
 * @property {number} UPDATE Allows user to update records (UPDATE DML Statement)
 * @property {number} DELETE Allows user to delete records (DELETE DML Statement or "IsDeleted=true")
 * @property {number} MERGE Allows user to perform a merge on records (Create or Update based on id) (MERGE DML Statement)
 * @property {number} PII Allow user to see PII information on the record
 * @property {number} EXECUTE Allow user to perform execution actions on the object
 * @property {number} KEYS Allows user to see Key values (a watered down read, when keys are needed, but not the rest of the record)
 * @property {number} COMMENTS Allows user to add comments to objects (comments cannot be changed or deleted)
 * @property {number} REFERENCES Allows user to maintain references to objects (CRUD)
 */
export var CRUD_PERMISSIONS;
(function (CRUD_PERMISSIONS) {
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["UNKNOWN"] = 0] = "UNKNOWN";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["CREATE"] = 1] = "CREATE";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["READ"] = 2] = "READ";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["UPDATE"] = 4] = "UPDATE";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["DELETE"] = 8] = "DELETE";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["MERGE"] = 16] = "MERGE";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["PII"] = 32] = "PII";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["EXECUTE"] = 64] = "EXECUTE";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["KEYS"] = 128] = "KEYS";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["COMMENTS"] = 256] = "COMMENTS";
  CRUD_PERMISSIONS[CRUD_PERMISSIONS["REFERENCES"] = 512] = "REFERENCES";
})(CRUD_PERMISSIONS || (CRUD_PERMISSIONS = {}));